import FolderService from '@/services/folder.service';
import Folder from '@/store/models/folder';

export default {
  namespaced: true,
  state: {
    activeFolderId: null,
  },
  mutations: {
    activeFolderId(state, folderId) {
      state.activeFolderId = folderId;
    },
  },
  actions: {
    init({ dispatch }) {
      return dispatch('getFolders');
    },
    terminate() {
      return Folder.deleteAll();
    },
    async getFolders() {
      const folders = await FolderService.getFolders();
      if (folders && Array.isArray(folders)) {
        await Folder.create({ data: folders });
      }
      return folders;
    },
    async createFolder(store, folder) {
      if (!folder.id) {
        folder = new Folder(folder);
      }
      const now = new Date().toISOString();
      folder.created_at = now;
      folder.updated_at = now;
      const res = await FolderService.createFolder(folder);
      await Folder.insert({ data: res });
      return res;
    },
    async updateFolder(store, folder) {
      folder.updated_at = new Date().toISOString();
      const res = await FolderService.updateFolder(folder);
      await Folder.insert({ data: res });
      return res;
    },
    async deleteFolder(store, folderId) {
      await FolderService.deleteFolder(folderId);
      await Folder.delete(folderId);
    },
  },
  getters: {
    activeFolderId(state) {
      return state.activeFolderId;
    },
    all() {
      return Folder.query().where('$isNew', false).get();
    },
    roots() {
      return Folder.query()
        .where('$isNew', false)
        .where('parent_id', null)
        .get();
    },
    activeFolder(state) {
      if (!state.activeFolderId) return null;
      return Folder.find(state.activeFolderId);
    },
  },
};
